
export class GrnItemIdRequest {
    grnItemId?: number;
    /**
     * 
     * @param grnItemId 
     */
    constructor(grnItemId?: number){
        this.grnItemId=grnItemId;
    }
}

export class GrnIDRequest {
    batchNumber:string;
    grnId?: number;
    year?:string
    /**
     * 
     * @param grnId 
     */
    constructor(    batchNumber:string,
        grnId?: number,
        year?:string
    ){
            this.batchNumber=batchNumber
        this.grnId=grnId;
        this.year = year
    }
}